import { useState, useEffect } from "react";
import { View, TextInput, StyleSheet, TouchableOpacity, Text } from "react-native";

export function Page17({ handleClick }) {

  const [emailValue, setEmailValue] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  
  const handleEmailChange = (event) => {
    setEmailValue(event);
  };
  
  const handleCheckboxClick = () => {
    setIsChecked(!isChecked);
  };
  
  useEffect(() => {
    // This effect will be triggered whenever emailValue or isChecked changes
    handleClick('email', { emailValue });
    handleClick('promotionalConsent', { isChecked });
  }, [emailValue, isChecked]);

  return (
    <View style={styles.container}>
       <View style={styles.center}>
        <TextInput
          style={styles.input}
          placeholder="email"
          value={emailValue}
          onChangeText={handleEmailChange}
        />
        </View>
        <View style={styles.checkBox}>
      <TouchableOpacity onPress={handleCheckboxClick}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View
          style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            borderWidth: 2,
            borderColor: isChecked ? '#3B1C15' : 'gray',
            marginRight: 8,
          }}
        >
          {isChecked && (
            <View
              style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text style={{ color: '#3B1C15', fontFamily:'DM Sans', fontSize:20 }}>✓</Text>
            </View>
          )}
        </View>
        <Text style={{ color: '#3B1C15', fontFamily:'DM Sans', fontSize:15 }}>By checking this box you consent to receiving marketing and promotional emails.</Text>
      </View>
    </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  input: {
    fontSize: 20,
    color: '#3B1C1580',
    backgroundColor: '#EFE7DE',
    textAlign: 'center',
    padding: 10,
    width: 300,
    alignItems: 'center',
    fontFamily: 'DM Sans'
  },
  container: {
    //flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  checkBox:{
    marginTop:30,
    alignContent: 'center',
    justifyContent: 'center',
    width: 300
    
  }
})